
// helpers.js
export const getPeriodsHistory = () => {
    const startPeriod = new Date('2023-09-01');
    const curDate = new Date();
    const [curY, curM] = [curDate.getFullYear(), curDate.getMonth()];
    const periods = [
        `${curM+1}.${curY}`
    ];

    for(;;) {
        const [cM, cY] = periods[periods.length - 1].split('.');
        
        const newM = (+cM-1) > 0 ? (+cM - 1) : 12;
        const newY = (+cM-1) > 0 ? (+cY) : (+cY - 1);
    
        if(new Date(newY, newM-1, 2) < startPeriod) break;
        
        periods.push(`${newM}.${newY}`);
    }

    return periods;
};

export const convData = (data) => {
    if(!data || !Array.isArray(data)) return [];
    return data.sort((a, b) => a.district.localeCompare(b.district) || a.kgnumber.localeCompare(b.kgnumber))
               .map((el, i) => Object.assign({}, el, { number: i + 1 }));
};

export const getTotal = (data, schema) => {
    const total = {};
    schema.forEach(item => {
        if (item.b) {
            total[item.f] = data.reduce((sum, el) => sum + (el[item.f] || 0), 0);
        }
    });
    return total;
};

export const Headers = ({ schema }) => (
    <tr>
        {schema.map((item, index) => (
            <th key={index} scope="col">{item.h}</th>
        ))}
    </tr>
);

export const Row = ({ schema, d }) => (
    <tr>
        {schema.map((item, index) => (
            <td key={index}>
                {item.btitle ? <b>{d[item.f]}</b> : d[item.f]}
            </td>
        ))}
    </tr>
);

export const Total = ({ schema, total }) => (
    <tr style={{ backgroundColor: '#333', color: '#ddd' }}>
        {schema.map((item, index) => (
            <td key={index}>
                {item.b ? <b>{total[item.f] || 0}</b> : (index === 1 ? 'Разом:' : '')}
            </td>
        ))}
    </tr>
);